import { Action, ErrorCodes, OperationType } from "puzzle";

export const getChartData: Action = [{
  condition: '{configurationToUpdate}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          dataIndex: '{configurationToUpdate.dataIndex}',
          hidden: '{configurationToUpdate.hidden}'
        }
      }
    },
    moduleName: 'MainGrid',
    name: 'changeChartFolderViewConfiguration',
    args: ['dataIndex', 'hidden']
  }],
  type: OperationType.conditional
}, {
  persistent: ['chartUrl', 'method'],
  type: OperationType.addPersistentData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: '{chartUrl}',
        params: '{payload}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'pingingRequestForChart',
  type: OperationType.action
}]

export const pingingRequestForChart: Action = [{
  condition: '!_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    condition: '{responseData} && {responseData.processingFinished}',
    conditionOperations: [{
      name: 'successPingForChart',
      type: OperationType.action
    }],
    elseOperations: [{
      actionType: {
        delay: 200
      },
      data: {
        template: {
          processId: {
            bind: {
              processId: '{responseData.processId}'
            }
          }
        }
      },
      name: 'continueWithPingingRequestForChart',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'stopChartPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]

export const continueWithPingingRequestForChart: Action = [{
  condition: '{chartUrl}',
  conditionOperations: [{
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    data: {
      template: {
        headers: {
          bind: {
            'X-Process-Uuid': '{processId.processId}'
          }
        },
        bind: {
          method: '{method}',
          url: '{chartUrl}'
        }
      }
    },
    mappingName: 'responseData',
    type: OperationType.request
  }, {
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    name: 'pingingRequestForChart',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'stopChartPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const successPingForChart: Action = [{
  name: 'getSubmissionsCount',
  type: OperationType.action
}, {
  moduleName: 'Statistics',
  name: 'setChartData',
  args: ['chartData', 'responseData']
}, {
  name: 'stopChartPingingRequest',
  type: OperationType.action
}]

export const getSubmissionsCount = [{
  data: {
    template: {
      params: {
        folder: 'DEFAULT_SUBMISSION',
        includeHidden: false,
        size: 50
      },
      bind: {
        chartData: '{responseData}'
      }
    },
  },
  type: OperationType.data
}, {
  data: {
    url: '/filters/submissionsCount',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}]

export const stopChartPingingRequest: Action = [{
  dispatcherIds: ['chartDispatcher'],
  type: OperationType.unlink
}]

export const loadEmptyChartData: Action = [{
  name: 'getSubmissionsCount',
  type: OperationType.action
}, {
  moduleName: 'Statistics',
  name: 'setEmptyChartData',
  args: ['responseData']
}]

export const updateFolderViewData: Action = [{
  moduleName: 'MainGrid',
  name: 'changeChartFolderViewConfiguration',
  args: ['dataIndex', 'hidden']
}]

export const dueSoonOverdueRowClick = [{
  moduleName: 'MainGrid',
  name: 'setOverrideSort',
}, {
  name: 'openPrefilteredSubmissionList',
  type: OperationType.action
}]